<template>
  <section>
    <!--
      «فقط پرداخت‌شده» در این صفحه بی‌معناست: موضوعِ گزارش خودِ سبدهای
      پرداخت‌نشده است.
    -->
    <report-filter-bar
      v-model="filter"
      :preset="preset"
      :busy="isAnyLoading"
      :compare-label="compareLabel"
      :show-paid-only="false"
      @preset="applyPreset"
      @change="refresh"
      @refresh="refresh"
    />

    <b-row class="match-height">
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-chart
          :series="trend"
          title="ارزش سبدهای رهاشده"
          subtitle="مجموع ارزش کالاهای سبدهایی که پرداخت موفق نداشتند"
          :metrics="['value']"
          type="area"
          :height="300"
          :loading="loading('trend')"
          :skin="skin"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-chart
          :series="trend"
          title="تعداد سبد رهاشده و بازیابی‌شده"
          :subtitle="rangeLabel"
          :metrics="['abandoned', 'recovered']"
          type="bar"
          :height="290"
          :loading="loading('trend')"
          :skin="skin"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="recovery"
          title="اثربخشی پیامک بازیابی"
          subtitle="نرخ پرداخت به تفکیک تعداد پیامک یادآوری که برای سبد ارسال شده"
          label-title="تعداد پیامک"
          :show-share="false"
          :loading="loading('recovery')"
          empty-text="هنوز پیامک بازیابی ارسال نشده است"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card no-body>
          <b-card-body class="d-flex align-items-center justify-content-between flex-wrap">
            <div>
              <h5 class="mb-25">
                فهرست سبدهای رهاشده
              </h5>
              <span class="text-muted small">برای تماس یا پیگیری تک‌به‌تک، به صفحه‌ی سفارش‌های رهاشده بروید</span>
            </div>
            <b-button
              variant="outline-primary"
              size="sm"
              @click="$router.push({ name: 'abandonedorder' })"
            >
              <feather-icon
                icon="ExternalLinkIcon"
                size="14"
              />
              <span class="ml-25">مشاهده فهرست</span>
            </b-button>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BCardBody } from 'bootstrap-vue'
import reportMixin from '@core/mixins/report'

export default {
  name: 'ReportAbandoned',
  components: { BCardBody },
  mixins: [reportMixin],
  data() {
    return {
      trend: null,
      recovery: null,
    }
  },
  computed: {
    compareLabel() {
      return this.trend && this.trend.CompareRange ? this.trend.CompareRange.Label : null
    },
  },
  created() {
    this.filter.PaidOnly = false
    this.refresh()
  },
  methods: {
    refresh() {
      this.fetchReport('trend', this.$api.report.abandonedTrend)
      this.fetchReport('recovery', this.$api.report.abandonedRecovery)
    },
  },
}
</script>
